// @ts-ignore
import { GandalfArray } from 'gandalf';
// @ts-ignore
import { GandalfConstantDecorator } from 'gandalf';
// @ts-ignore
import { GandalfLabel } from 'gandalf';
// @ts-ignore
import { GandalfModel } from 'gandalf';
// @ts-ignore
import { GandalfModelBase } from 'gandalf';
// @ts-ignore
import { GandalfProperty } from 'gandalf';
// @ts-ignore
import { GandalfSubRequestLabel } from 'gandalf';
// @ts-ignore
import { GandalfValidator } from 'gandalf';
// @ts-ignore
import * as constants from '../constants';


/** See com.rev360.pms.api.controller.admin.accounting.PracticeLocationTransferTaxResponse */
/* istanbul ignore next */
@GandalfModel
export class PracticeLocationTransferTaxResponse extends GandalfModelBase {

	@GandalfProperty({ designType: Number })
	id!: number | null;

	@GandalfProperty({ designType: Number })
	sortOrder!: number | null;

	@GandalfProperty({ designType: Number })
	taxId!: number | null;

	@GandalfProperty({ designType: Number })
	transferReasonId!: number | null;

	@GandalfProperty({ designType: String })
	value!: string | null;

}
